var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "POS-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---App-views",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products",
    transform: "translate(-48, -865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-6",
    transform: "translate(24, 841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POS-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#00414B",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    x: 7,
    y: 28,
    width: 17,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    stroke: "#00414B",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "8.5 4.70154454 10.907211 24.2896422 20.8008013 24.2896422 23.0692693 4.70154454"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosIcon);
export default __webpack_public_path__ + "static/media/POS-icon.cdccb6cfa7260042310520dfc4be3832.svg";
export { ForwardRef as ReactComponent };